"use client";

import { useConvexAuth } from "convex/react";
import { ReactNode } from "react";
import { SignInPage } from "@/app/auth/SignInPage";

export function AuthGate({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useConvexAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <SignInPage />;
  }

  return <>{children}</>;
}
